exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".gantt-elastic__chart-row-text[data-v-26409f00]{pointer-events:none}", ""]);

// exports
